/**
 * ver 0.1
 * author jack
 * created 18-12-10
 */
import React from 'react'
import axios from 'axios'
import styled from 'styled-components'

import LoginLayer from './loginLayer'
import DefaultLayer from './defaultLayer'
import { setCompareView, updateLikeCompareItem } from "../../libs/action";
import { connect } from 'react-redux';

class ZzimLayer extends React.Component {
    constructor(props) {
        super(props)

        let { f_div, idx, selected, itemInfo, index, pageType } = props

        this.state = {
            componentMount: false,
            componentUpdate: true,
            f_div,
            idx, // 상품 번호
            index, // 현재 담겨진 상품의 index ex) 0,1,2,3...
            selected,
            itemInfo,
            pageType, // 1: 상품사양 비교 새창
            zzimGroups: [],
            selectZzimGroup: 0,
            isLogin: true,
            showAddGroup: false,
            groupName: '',
            layerError: false,
            defaultLayer: 0,
        }

        this.apiUrl = process.env.REACT_APP_API_URL
        this.config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.componentUpdate
    }

    componentDidMount() {
        if (this.state.selected) {
            let _params = {
                f_div: this.state.f_div,
                idx: this.state.idx,
            }

            axios.post(this.apiUrl + '/front/v2/zzim/del', _params, this.config).then(res => {
                if (res.data.code === 200) {
                    this.onDefaultLayer(2)
                } else {
                    this.setState({ isLogin: false, componentMount: true, componentUpdate: true })
                }
            })
        } else {
            axios.get(this.apiUrl + '/front/v2/zzim/group', this.config).then(res => {
                if (res.data.code === 200) {
                    this.setState({
                        zzimGroups: res.data.result,
                        selectZzimGroup: res.data.result[0].gid_zzim,
                        componentUpdate: true,
                        componentMount: true,
                    })
                } else {
                    this.setState({ isLogin: false, componentMount: true, componentUpdate: true })
                }
            })
            this.onPopupStyle(false)
        }
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (this.state.componentUpdate === true) {
            this.setState({ componentUpdate: false })
        }
    }

    componentWillUnmount() {
        this.onPopupStyle(true)
    }

    onPopupStyle = (state) => {
        document.querySelector('#header').style.opacity = state ? 1 : 0
        if (this.props.pageType === 1) { // 상품 비교 새창일 떄
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = state ? 'visible' : 'hidden'
        }
    }

    onShowAddGroup() {
        this.setState({
            showAddGroup: !this.state.showAddGroup,
            groupName: '',
            componentUpdate: true,
        })
    }

    onAddGroup() {
        let groupName = this.state.groupName
        if (groupName === '') {
            this.setState({ layerError: true })
            return false
        }
        let _params = {
            f_div: 99,
            gname: groupName,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(3)
                this.setState({ zzimGroups: res.data.result, groupName: '', componentUpdate: true })
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    /**
     * 상품 비교 하단창 찜하기
     * @param number 0: 상품 찜 안한 상태 1: 상품 찜한 상태
     */
    updateLikeCompareItems(number) {
        const itemIndex = this.state.index
        this.props.updateLikeCompareItem(itemIndex, number)
    }

    onAddZzim() {
        let _params = {
            f_div: this.state.f_div,
            idx: this.state.idx,
            gid_zzim: this.state.selectZzimGroup,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(1)
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    onSelectZzimGroup(e) {
        this.setState({ selectZzimGroup: parseInt(e.target.value, 10), componentUpdate: true })
    }

    groupName(e) {
        this.setState({ groupName: e.target.value, componentUpdate: true })
    }

    onDefaultLayer(t) {
        // t = (0 : 닫기, 1 : 찜하기, 2 : 찜삭제, 3 : 찜그룹 등록)
        if (t === undefined) {
            t = 0
            if (this.state.defaultLayer === 2) {
                this.props.onClose(false)
            } else if (this.state.defaultLayer === 1) {
                this.props.onClose(true)
            }
        }
        this.setState({ defaultLayer: t, componentMount: true, componentUpdate: true })
    }


    /**
     * 상품비교 하단창에서 찜하기 선택 시 상품 리스트 찜하기 상태 변경
     * @param number 0: 상품 찜 안한 상태 1: 상품 찜한 상태
     */
    changeZzimInfo(number) {
        const itemElement = document.getElementById(`item_${this.props.idx}`)
        const itemZzimCount = document.getElementById(`item_zzim_${this.props.idx}`)

        if (itemElement !== null) {
            if (number === 1){
                if (itemElement.parentNode.className === 'button zzim') {
                    itemElement.parentNode.className = 'button zzim active'
                }
                itemZzimCount.innerText = Number(itemZzimCount.innerText)+1 // 상품 리스트 찜하기 갯수 상승
            }
            if (number === 0){
                if (itemElement.parentNode.className === 'button zzim active') {
                    itemElement.parentNode.className = 'button zzim'
                }
                itemZzimCount.innerText = Number(itemZzimCount.innerText)-1
            }
        }
    }

    /**
     * 상품사양 비교 좋아요 반영
     * @param number
     */
    changeItemCompareLike(number) {
        let cloneCompareView = [...this.props.compareView]
        let itemIndex = this.props.index
        cloneCompareView[itemIndex].item_info.zzim_my = number
        this.props.setCompareView(cloneCompareView)
    }

    render() {
        if (this.state.componentMount === false) return false
        if (this.state.isLogin === false) return <LoginLayer onClose={() => this.props.onClose(this.state.selected)} pageType={this.props.pageType} />
        if (this.state.defaultLayer === 1) {
            this.changeZzimInfo(1)
            if (this.props.itemInfo) { // itemInfo가 있는 경우는 상품 하단 비교창에서 찜할 떄
                this.updateLikeCompareItems(1)
            }
            if (this.props.pageType === 1) { // 상품사양 비교 새창일 떄
                this.changeItemCompareLike(1)
            }
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()} pageType={this.props.pageType}>
                    <span>해당 상품을 <b>선택한 그룹에<br/> 저장</b> 하였습니다.</span>
                </DefaultLayer>
            )
        }
        if (this.state.defaultLayer === 2) {
            this.changeZzimInfo(0)
            if (this.props.itemInfo) {
                this.updateLikeCompareItems(0)
            }
            if (this.props.pageType === 1) {
                this.changeItemCompareLike(0)
            }
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()} pageType={this.props.pageType}>
                    <span>해당 상품이 <b>찜하기에서<br/>제외</b> 되었습니다.</span>
                </DefaultLayer>
            )
        }
        if (this.state.defaultLayer === 3) {
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()} pageType={this.props.pageType}>
                    <span>그룹이 <b>추가</b> 되었습니다.</span>
                </DefaultLayer>
            )
        }
        if (this.state.selected) return false

        return (
            <Style id="lyrPop" style={{background: 'rgba(0,0,0,0.75)', border : '2px solid #333333'}}>
                <tbody>
                    <tr>
                        <td className="">
                            <div className="PopMain zzimPop">
                                <strong className="popName">상품 찜하기</strong>
                                <b className="zzimB">선택한 상품을 그룹에 저장 합니다.</b>
                                <div className="zzGrpList">
                                    {this.state.zzimGroups.map((v, i) => {
                                        let radioId = 'zzimRadio_' + i
                                        let checked = this.state.selectZzimGroup === v.gid_zzim
                                        return (
                                            <div className="zzGrp" key={i}>
                                                <span className="zzLeft iradio">
                                                    <input
                                                        type="radio"
                                                        name={radioId}
                                                        id={radioId}
                                                        checked={checked}
                                                        onChange={e => this.onSelectZzimGroup(e)}
                                                        value={v.gid_zzim}
                                                    />
                                                    <label htmlFor={radioId} className="zzimLabel">{v.gname}</label>
                                                </span>
                                                <span className="zzRight zCnt">{v.cnt}</span>
                                            </div>
                                        )
                                    })}
                                    {this.state.showAddGroup && (
                                        <div className="zzGrp blind">
                                            {/* 그룹명 최대 15글자 입력제한 */}
                                            <span className="zzLeft">
                                                <input
                                                    maxLength={15}
                                                    type="text"
                                                    className="zzimInp"
                                                    value={this.state.groupName}
                                                    onChange={e => this.groupName(e)}
                                                    placeholder="그룹명을 입력하세요."
                                                />
                                            </span>

                                            <span className="zzRight">
                                                <button className="styWBg" onClick={() => this.onAddGroup()}>
                                                    추가
                                                </button>
                                                <button
                                                    className="styNor icon-X_close"
                                                    onClick={() => this.onShowAddGroup()}
                                                />
                                            </span>
                                        </div>
                                    )}
                                    {this.state.layerError &&
                                        {
                                            /* <div><span>그룹명을 작성해 주세요</span></div> */
                                        }}
                                </div>
                                {!this.state.showAddGroup && (
                                    <div className="zzimGrpAdd">
                                        <button
                                            className="styWBg icon-add_circle"
                                            onClick={() => this.onShowAddGroup()}
                                        >
                                            그룹 추가하기
                                        </button>
                                    </div>
                                )}
                                <div className="zzImNoti">
                                    <p>ㆍ찜한 내역은 각 그룹별 최대 100개까지 저장</p>
                                    <p>ㆍ찜한 내역은 찜한 날짜로부터 180일 동안 저장</p>
                                </div>
                                <div className="popDefBtns">
                                    <button
                                        className="icon-X_close"
                                        onClick={() => this.props.onClose(this.state.selected)}
                                    />
                                    <CancelButton type="button" className="confBtn" onClick={() => this.props.onClose(this.state.selected)}>
                                        취소
                                    </CancelButton>
                                    <button type="button" className="confBtn styPBg" onClick={() => this.onAddZzim()}>
                                        확인
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Style>
        )
    }
}

const Style = styled.table`
    .zzimLabel {
        position: relative
    }
    .zzimGrpAdd {
        button {
            line-height: 18px!important
        }
    }
`

let stateData = (state) => {
    return {
        compareItems: state.estimateAdd.compareItems,
        compareView: state.estimateAdd.compareView
    }
}

let dispatchData = (dispatch) => {
    return {
        updateLikeCompareItem: (itemIndex, zzimSelected) => dispatch(updateLikeCompareItem(itemIndex, zzimSelected)),
        setCompareView: (compareView) => dispatch(setCompareView(compareView))
    }
}
export default connect(stateData, dispatchData)(ZzimLayer)

const CancelButton = styled.button`
    background: none !important;
    border: 2px solid #418ded !important;
    color: #418ded !important;
    font-size: 16px !important;
    font-weight: bold !important;
    height: 42px !important;
    line-height: 38px !important;
    margin: 0 3px !important;
    min-width: 125px !important;
    padding: 0 30px !important;

    &:hover {
        background-color: #f6f6f6 !important;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/zzimLayer.js